import { useState } from 'react';

import { useAuth } from '../../shared';
import { Dropdown } from '../../components';
import { Button, SubmitButton } from '../../components';
import { Modal, Form, FormItem } from '../../components';
import type { TransferCampaignToOrganizationPayload } from '../../api';

type Payload = TransferCampaignToOrganizationPayload;
type TransferModalProps = {
  loading: boolean;
  campaignId: string;

  onClose: () => void;
  onSumbit: (payload: Payload) => void;
};

type FormType = TransferCampaignToOrganizationPayload;

const TransferModal: React.FC<TransferModalProps> = ({
  loading,
  campaignId,
  onClose,
  onSumbit,
}) => {
  const { orgs, organization_id } = useAuth();
  const [values, setValues] = useState<FormType>({
    campaignId,
    organizationId: '',
  });

  const handleSubmit = () => onSumbit(values);

  return (
    <Form<FormType> initialValue={values} onChange={setValues}>
      <Modal
        open
        size="small"
        onClose={onClose}
        title="Transfer Campaign"
        bottomActions={
          <>
            <SubmitButton
              type="primary"
              loading={loading}
              onClick={handleSubmit}
            >
              Transfer
            </SubmitButton>
            <Button onClick={onClose}>Cancel</Button>
          </>
        }
      >
        <div className="flex flex-col gap-y-md">
          <FormItem<FormType>
            label="Organization"
            name="organizationId"
            required
          >
            <Dropdown
              options={orgs
                .map(o => ({ value: o.id, label: o.name || '' }))
                .filter(o => o.value && o.value !== organization_id)}
            />
          </FormItem>
        </div>
      </Modal>
    </Form>
  );
};

export default TransferModal;
